import React, { Component } from "react";
import { Grid, Button, GridColumn, Icon } from "semantic-ui-react";
import PeriodSlider from "./PeriodSlider";
import EventSlider from "./EventSlider";
import EventSliderIndex from "./EventSliderIndex";
import EventsCategoryIndicator from "../Shared/EventsCategoryIndicator";
import OwlCarousel from "react-owl-carousel2";
import { FixedSizeList as List } from "react-window";
import { Link } from "react-router-dom";
import axios from "axios";
import { BrowserView, MobileView, isBrowser, isMobile, isTablet, withOrientationChange } from "react-device-detect";
const sampleData = require("./data/sampleData.json");
const eventCat = require("./data/eventCategory.json");
const { apiUrl } = require('./config')
var _ = require('lodash');

  function go() {
    var querystring = window.location.search.replace(/^\?/, '');
    // console.log('querystring', querystring)
    var params = {};
    querystring.replace(/([^=&]+)=([^&]*)/g, function (m, key, value) {
    params[decodeURIComponent(key)] = decodeURIComponent(value);
    });
    const token = encodeURIComponent(params['token'])
    // console.log('token', token)
    
    const content_type = encodeURIComponent(params['content_type'])
    // console.log('content_type', content_type)

    return `${apiUrl}/api/v2/page_preview/1/?content_type=${content_type}&token=${token}&format=json`
   }

  function isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }


  // function timelineListShowEvent() {
  //   return `${apiUrl}/api/v2/pages/?type=home.TimelineEvent&fields=*&show_event=true`
  // }

  function timelineListEvents() {
    return `${apiUrl}/api/v2/pages/?type=home.TimelineEvent&fields=*&show_event=false`
  }

  function getPeriodCategorySnippets() {
    var url = `${apiUrl}/api/v2/snippets/period/?fields=*`
    return axios.get(url)
      .then(res => {
        const data = res.data;
          return data
      })
      .catch(error => {
        console.error(error);
      });
  }

  function timelineListShowEvent() {
    var url = `${apiUrl}/api/v2/pages/?type=home.TimelineEvent&fields=*&show_event=true`
    return axios.get(url)
      .then(res => {
        const data = res.data;
          return data
      })
      .catch(error => {
        console.error(error);
      });
  }

  function getVolumeCategorySnippets() {
    var url = `${apiUrl}/api/v2/snippets/volume/?fields=*`
    return axios.get(url)
      .then(res => {
        const data = res.data;
          return data
      })
      .catch(error => {
        console.error(error);
      });
  }

  function getTimelinePeriods() {
    var url = `${apiUrl}/api/v2/pages/?type=home.TimelinePeriod&fields=*`
    return axios.get(url)
      .then(res => {
        const data = res.data;
          return data
      })
      .catch(error => {
        console.error(error);
      });
  }

  function dataAssign(period, data, periodCat, volumeCat, resData) {
    console.log("resData1",resData)
    console.log("dataAssigndataAssign",data)
    console.log("eventCat",eventCat)
    console.log("dataAssignperiodCat",periodCat)
    console.log("periodperiod",period)

    data.items.forEach((item)=> {
        item.periods.forEach((i)=>{
          var periodFilter = period.filter((per)=>{
            return per.period_id == i.id
            // return Object.assign({}, item, {
            //   // period: item.period,
            //   periodId: item.period_id,
            //   list: []
            // })
          })
          // console.log("periodFilter", periodFilter)

          // var samp = periodFilter.filter((i)=>{
          //   return i.period_id == resData.period_id
          // })

          // console.log("samppppp1", samp)

          item['periodId'] = periodFilter[0].period_id
          i['periodName'] = periodFilter[0].period_name

          // if(samp.length != 0){
          //   item['xxxxx'] = 'ssssss'
          // }
          
        })
        item.categories.forEach((cat)=>{
          var volFilter = volumeCat.filter((vol)=>{
            return vol.slug == cat.id
          })
          // console.log("volFilter", volFilter)

          item['categoryId'] = cat.id
          item['category'] = volFilter[0].name
        })
      })


    // console.log("datadatadata",data)

    // var samp = data.items.map((item)=>{

    //   return item.periodId == resData.period_id
    // })


    var grouped1dataAssign = _.mapValues(_.groupBy(data.items, 'periodId'),
      clist => clist.map(item => _.omit(item, 'periodId')));

      // console.log('grouped1dataAssign', grouped1dataAssign);

      // var samp1 = period.filter((i)=>{
      //       return i.period_id == resData.period_id
      //     })

      //     console.log("samppppp1111", samp1)

          var perFilter = period.filter(i => i.period_id == resData.period_id).map(item=>{
            return Object.assign({}, item, {
              // period: item.period,
              background_image: resData.background_image,
              background_image_category: resData.background_image_category,
              description: resData.description,
              end_year: resData.end_year,
              id: resData.id,
              period_color: resData.period_color,
              period_id: resData.period_id,
              period_image: resData.period_image,
              period_name: resData.period_name,
              period_slider_display_name: resData.period_slider_display_name,
              start_year: resData.start_year,
              title: resData.title,
            })
          })

          // console.log("samppppp1", perFilter)

      var temp = period.map((item)=>{
        return Object.assign({}, item, {
          // period: item.period,
          periodId: item.period_id,
          list: []
        })
      })
      
      // console.log('sdperiod', temp)

      temp.forEach((period, ind)=> {
        // console.log("periodperiodperiod", period)
        period.list = grouped1dataAssign[period.period_id]
        if(period.list === undefined){
          period.list = []
        }
        if(period.period_id == perFilter[0].period_id){
          var pr = perFilter.map((item)=>{
            return Object.assign({}, item, {
              list: period.list
            })
          })
          temp[ind] = pr[0]
          }
      })
  // console.log('Tempp', temp)
  var tempSort =_.sortBy(temp, [function(o) { return parseInt(o.period_id); }]);
  // console.log('TemnewArrtempppxxx', tempSort)
  return tempSort
}


class TimelineIndex extends Component {
   state = {
     eventItem: {},
     timelineData: []
   }

  componentWillMount = () => {
    var that = this;
    var url = timelineListShowEvent() 
    var urlGo = go()


     axios.get(urlGo)
      .then(res => {
        const resData = res.data;
        timelineListShowEvent().then(data => {
          getPeriodCategorySnippets().then(output => {
            getVolumeCategorySnippets().then(vol => { 
              getTimelinePeriods().then( period => {
                var dataAssignArr = dataAssign(period.items, data, output.items, vol.items, resData)
                this.setState({
                  timelineData: dataAssignArr,
                  periods: output.items,
                  volumes: vol.items,
                  timelinePeriods: period.items
                });
              })
            })
          })
        })
      })
    
    // console.log("that.state", this.state)
 
  }

  openNav = (e) => {
    this.setState({
      sideBarMenu: true
    })
  }

  closeNav = (e) => {
    this.setState({
      sideBarMenu: false
    })
  }

  render() {
    console.log("states", this.state);
    return (
      <div>
        <PeriodCoverIndex {...this.state} 
          handleOpenNav = {this.openNav}
          handleCloseNav = {this.closeNav}
          />
        {/* <EventSlider {...this.state}/> */}
        
      </div>
    );
  }
}

export default TimelineIndex;

const PeriodCoverIndex = props => {
  // console.log("PeriodCoverxx", props);
  const { timelineData, periods, volumes } = props;
  const options = {
    items: 5,
    //   nav: true,
    rewind: true
    //   autoplay: true
  };

  return (
    <div className="" style={{marginBottom: `${isMobile ? '0rem' : '13rem'}` }}> 
      {timelineData.map(item => {
        return (
          <div
            className="container-fluid col-xl-12 h-100 bg-img-fixed p-0"
            style={{
              backgroundImage: `url('${item.background_image.meta.download_url}')`,
              backgroundColor: `${item.period_color}`,
              backgroundBlendMode: "soft-light"
            }}
          >
            <div className="bg-dark-gradient" id={`id${item.id}`} name={`id${item.id}`}>
              <Grid className="m-0">
                <Grid.Column width={16} className="p-5 text-center">
                  <div className="col-12">
                    <p className="text-white text-uppercase small-2 font-sans-serif-Roboto font-weight-bold period-header">
                      Digital Index
                    </p>
                    
                    {/* <div>
                      <Link to="/event2" params={{ testvalue: "hello" }}>
                        Click here to go back to home page
                      </Link>
                    </div> */}
                  </div>
                  <div className="pt-3">
                    <p className="text-white font-sans-serif-Fjalla large-5 period-title-header py-05 sss">
                      {item.period_name}
                    </p>
                    <p className="text-white font-sans-serif-Fjalla large-5 period-title-header opacity-normal">
                      {item.start_year}-{item.end_year}
                    </p>
                  </div>
                </Grid.Column>
                <Grid.Column width={16}>
                  <div className="row">
                    <div className="col-md-7 p-0">
                      <img src={item.period_image.meta.download_url} className="period-image mb-4"/>
                    </div>
                    <div className="col-md-5 pr-0 text-left">
                    <Link className="link-event" to={{
                      pathname: `periodEvent/${item.periodId}`,
                      state: {
                        fromNotifications: true,
                        modal: true,
                        items: props.timelineData,
                        periods: props.periods,
                        volumes: props.volumes
                      }
                      }}>
                      <Button
                        className="rounded-0 btn-period p-1"
                        content="See Events"
                        icon="right arrow"
                        labelPosition="right"
                      /></Link>
                      <div>
                        <p className="text-white font-sans-serif-Fjalla period-title mt-3 mr-5">
                          {item.period_title}
                        </p>
                        <div className="row mr-0">
                          <div className="col-md-12">
                            <p className="text-white period-description pr-5">
                              {item.description}
                            </p>
                            <div className="position-relative">
                              <a href={`#event${item.id}`}>  <Button
                                className="rounded-0 btn-period-scroll p-1"
                                content="Scroll Down"
                              >
                                <Icon name="long arrow alternate left" />
                                Scroll Down
                              </Button></a>
                            
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid.Column>
                </Grid>
                {isMobile ? 
                <div>
                  <div id="mySidenav" class={`sidenav ${props.sideBarMenu == true ? 'w-100 zIndex-999 text-center' : ''}`}>
                    <a href="javascript:void(0)" class="closebtn" onClick={props.handleCloseNav}>&times;</a>
                    <h5 className="text-white mb-2">Timeline Periods</h5>
                    {props.timelineData.map(item => {
                          return (
                            <a className="pb-0" href={`#id${item.id}`} onClick={props.handleCloseNav}>
                              <div className="">
                                    {item.period_slider_display_name}
                              </div>
                            </a>
                          );
                        })}
                  </div>

                  <Button circular className="sidenav-btn-left" icon='bars' onClick={props.handleOpenNav}/>
                </div> 
                : 
                <div>
                  <Grid className="m-0">
                  <Grid.Column width={16} className="period_slider sss">
                    <div>
                      <OwlCarousel loop margin={10} nav options={options}>
                        {props.timelineData.map(item => {
                          return (
                            <a href={`#id${item.id}`}>
                              <div className="p-2">
                                <div
                                  className="position-relative"
                                  style={{
                                    backgroundColor: `${item.period_color}`
                                  }}>
                                  <img className="period-slider-img" src={item.background_image.meta.download_url} />
                                  <div className="center-div period-slider-title bg-black-light text-white">
                                    {item.period_slider_display_name}
                                  </div>
                                </div>
                              </div>
                            </a>
                          );
                        })}
                      </OwlCarousel>
                    </div>
                  </Grid.Column>
                  </Grid>
                </div>
                }
      
                
              
            </div>
            <Grid className="m-0 events" style={{ backgroundColor: "rgba(0, 0, 0, 0.80)" }}>
              {/* <Grid.Column width={2} className="p-5"></Grid.Column> */}
              <Grid.Column width={16} className={`pt-5 pb-5 ${item.list.length == 0 ? 'd-none': 'd-block'}`} id={`event${item.id}`}>
                <Events 
                eventList={item.list} 
                periods={periods}
                volumes={volumes}
                timelineData={item}/>
                {/* <EventItem eventItem={eventItem} /> */}
              </Grid.Column>
            </Grid>
          </div>
        );
      })}
    </div>
  );
};

const Events = props => {
  // console.log("eventsprops", props);
  return (
    <div class="">
      {props.eventList.map(item => {
        return (
          <div id={`id${item.id}`} name={`id${item.id}`}>
            {/* <Link className="link-event" to={`event/${item.Index_id}`}> */}
            <Link className="link-event" to={{
                pathname: `eventIndex/${item.id}`,
                state: {
                  fromNotifications: true,
                  modal: true,
                  items: props.timelineData,
                  periods: props.periods,
                  volumes: props.volumes
                }
              }}>
              <EventSliderIndex {...props} />
              <Grid className="m-0">
                <Grid.Column width={8} className="p-0">
                  <div className="pr-4">
                    <div className="padding-05 pb-5 pt-0">
                      <p className={`event-title-header text-right text-white ${item.display_name == " " || item.display_name == null && item.start_date == "" || item.start_date == null ? "d-none" : 
                    "d-block"}`}>
                        {item.display_name == " " || item.display_name == null
                          ? item.start_date
                          : item.display_name}
                      </p>
                      <p className="event-description text-right text-white sss">
                      <div  dangerouslySetInnerHTML={{__html: item.description}} />
                      </p>
                    </div>
                  </div>
                </Grid.Column>
                <Grid.Column width={8} className="p-0 event-desc-container">
                  <div>
                    <EventsCategoryIndicator category={item.category} />
                    {/* {isEmpty('photo') ? 'sdsad': 'xxxx'} */}
                    {item.photo == null ? "" :
                    <img className="event-image " align="left" src={item.photo.url} />}
                  </div>
                </Grid.Column>
              </Grid>
            </Link>
          </div>
        );
      })}
    </div>
  );
};
